import { render } from "./order_edit.vue?vue&type=template&id=2aa74d98"
import script from "./order_edit.vue?vue&type=script&lang=js"
export * from "./order_edit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__